/**
 * Export all constructs under the models namespace.
 */

export * from "@courses-models/institution/src/ts/models/InstitutionClassCollection";
export * from "@courses-models/institution/src/ts/models/InstitutionGradeCollection";
export * from "@courses-models/institution/src/ts/models/InstitutionTeacherCollection";
export * from "@courses-models/institution/src/ts/models/InstitutionTeamCollection";
export * from "@courses-models/institution/src/ts/models/InstitutionModel";
